import * as tslib_1 from "tslib";
import { Base } from '../../components/base-component';
import { AnalyticsService } from '../../services/analytics.service';
import './form-item-angola-salesforce.component.scss';
var FormItemAngolaSalesforce = /** @class */ (function (_super) {
    tslib_1.__extends(FormItemAngolaSalesforce, _super);
    function FormItemAngolaSalesforce(element) {
        return _super.call(this, element) || this;
    }
    FormItemAngolaSalesforce.prototype.init = function () {
        // this.form = this.element.querySelector('form') as HTMLFormElement;
        this.buttonSubmit = Array.from(this.element.querySelectorAll('.js-submit__salesforce-form'));
    };
    FormItemAngolaSalesforce.prototype.bindEvents = function () {
        var _this = this;
        if (this.buttonSubmit) {
            this.buttonSubmit.map(function (item) { return item.addEventListener('click', function (event) {
                var element = event.target;
                var form = element.closest('form');
                var formFields = form.querySelectorAll('input, select');
                var validation = _this.validationService.validateEnterprise(formFields);
                if (validation.valid) {
                    _this.actionForm(form);
                }
            }); });
        }
    };
    FormItemAngolaSalesforce.prototype.actionForm = function (form) {
        // containers
        var hiddenInputs = Array.from(form.querySelectorAll('input[type=hidden'));
        var loader = form.querySelector('.form__loader--container');
        var thankyou = form.querySelector('.form__thankyou--container');
        var fieldsContainer = form.querySelector('.form__fields--container');
        loader.classList.add('active');
        fieldsContainer.classList.add('hidden');
        // other fields
        var reason = undefined;
        var name = form.querySelector('input[name=name]');
        var phone = form.querySelector('input[name=phone]');
        var email = form.querySelector('input[name=email]');
        var subjectField = form.querySelector('select[name=subject]');
        if (form.querySelector('input[name=reason]')) {
            reason = form.querySelector('input[name=reason]');
        }
        else {
            reason = form.querySelector('select[name=Reason]');
        }
        var sub = form.querySelector('select[name=Sub]');
        var comments = form.querySelector('textarea[name=description');
        var pageUrl = window.location.href;
        var fields = {
            name: name.value,
            email: email.value,
            phone: phone.value,
            subject: subjectField.value,
            description: "Reason:" + reason.value + "; Sub:" + sub.value + "; Comments:" + comments.value + ";"
        };
        hiddenInputs.map(function (field) {
            var getName = field.getAttribute('name');
            var getValue = field.value;
            fields[getName] = getValue;
        });
        fields.retURL = window.location;
        // fields.debug = 0;
        // fields.debugEmail = 'john.fourie@standardbank.co.za';
        // DEV
        // fields.orgid = '00D3N0000002fqM';
        // fields.recordType = '0122X000000oqvL';
        // SIT
        // fields.orgid = '00D3N00000042YY';
        // fields.recordType = '0122X000000oqvL';
        // UAT
        // fields.orgid = '00D3N0000002wX8';
        // fields.recordType = '0122X000000oqvL';
        // PROD
        fields.orgid = '00D200000000Uno';
        fields.recordType = '0122X000000oqvL';
        var customHiddenIframeName = "JLA_API";
        if (!document.getElementById(customHiddenIframeName)) {
            var theiFrame = document.createElement("iframe");
            theiFrame.id = customHiddenIframeName;
            theiFrame.name = customHiddenIframeName;
            theiFrame.src = "about:blank";
            theiFrame.style.display = "none";
            document.body.appendChild(theiFrame);
        }
        var form = document.createElement("form");
        form.method = "POST";
        // DEV
        // form.action = "https://standardbank--bcwaogdev.my.salesforce.com/servlet/servlet.WebToCase?encoding=UTF-8";
        // SIT
        // form.action = "https://standardbank--sit.my.salesforce.com/servlet/servlet.WebToCase?encoding=UTF-8";
        // UAT
        // form.action = "https://standardbank--bcwuat.my.salesforce.com/servlet/servlet.WebToCase?encoding=UTF-8";
        // PROD
        form.action = "https://standardbank.my.salesforce.com/servlet/servlet.WebToCase?encoding=UTF-8";
        form.setAttribute("target", customHiddenIframeName);
        for (var fieldName in fields) {
            var theInput = document.createElement("input");
            theInput.name = fieldName;
            theInput.value = fields[fieldName];
            theInput.setAttribute("type", "hidden");
            form.appendChild(theInput);
        }
        document.body.appendChild(form);
        form.submit();
        // analytics
        var analyticsService = new AnalyticsService();
        analyticsService.dtmFormComplete('complete', '');
        // service ok
        loader.classList.remove('active');
        thankyou.classList.add('active');
    };
    return FormItemAngolaSalesforce;
}(Base));
export { FormItemAngolaSalesforce };



//////////////////
// WEBPACK FOOTER
// ./components-angola/form-item-angola-salesforce/form-item-angola-salesforce.component.ts
// module id = 671
// module chunks = 0